import { IneligibilityReason as OfferIneligibilityReason } from '@ocx/graphql';
import { Offer } from './offer.types';
import { Eligible, IneligibilityHandlingStrategy, IneligibilityReason } from './eligibility.types';
import { inelegibilityReasonStrategyComparator } from './eligibility.utils';
import { isPurchaseVoucherOffer } from './offer.type-guards';

export type CalculateEligibilityContext = {
  membershipPoints: number;
};

export const calculateEligibility = (offer: Offer, context: CalculateEligibilityContext): Eligible => {
  const reasons: IneligibilityReason[] = [];

  if (offer.ineligibilityReason === OfferIneligibilityReason.PurchasableEligibilityConstraintFailed) {
    reasons.push({
      type: 'purchasable_eligibility_constraint_failed',
      strategy: IneligibilityHandlingStrategy.DisableLoyaltyAction,
    });
  }

  if (isPurchaseVoucherOffer(offer) && offer.earningMechanism.fulfilmentPrice > context.membershipPoints) {
    reasons.push({ type: 'not_enough_points', strategy: IneligibilityHandlingStrategy.DisableInteractions });
  }

  if (!reasons.length) {
    return [true];
  }

  const sortedReasons = reasons.sort(inelegibilityReasonStrategyComparator);
  return [false, sortedReasons[0].strategy, sortedReasons];
};
